import { OfferModel } from '../../../../offer/model/OfferModel';
import { OfferState } from '../../../../offer/model/OfferState';

export const isValidOfferWithPrice = (offer: OfferModel): boolean => {
    if (!offer.ppl) {
        return false;
    }

    return offer.state !== OfferState.ENQUIRY_DECLINED && offer.hasValidProducts();
};
